<section class="sideRight-body">
    <div style="flex-direction:column; height: 100%">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <!--<div><label class="font-class main-header">Manage Business Components</label> </div>-->
            <div>
                <a>
                    <i *ngIf="businessComponents.length<0" class="fas fa-times close-btn-class"
                        (click)="rightSideDrawerService.closeRightSideDrawer()"></i>
                    <i *ngIf="businessComponents.length<0" class="fas fa-times close-btn2-class"
                        (click)="rightSideDrawerService.closeRightSideDrawer()"></i>
                </a>
            </div>
            <div class="div_one" *ngIf="businessComponents.length>0">
                <section class="section_one">
                    <label class="bizComp-item margin-class-two noHover">{{businessComponents.length}} Business
                        Components</label>
                    <div class="bizComp-list">
                        <div *ngFor="let option of businessComponents; let i = index"
                            [ngClass]="{'highlighted': i === selectedIndex}" class="bizComp-item"
                            (click)="selectBizComp(option, i)">
                            {{ option.businessComponentName }} <label class="label_qPercent">{{
                                option.businessComponentQPercentage }}%</label>
                            <br />
                            <label class="label_qualified"
                                *ngIf="getFilteredCountAndPercentage(option.businessComponentId).count>0">{{
                                getFilteredCountAndPercentage(option.businessComponentId).count }} Projects </label>
                            <label class="label_qualified"
                                *ngIf="getFilteredCountAndPercentage(option.businessComponentId).count==0">
                                <i class="fa-solid fa-triangle-exclamation noProjLogo"></i> <label class="noProjLabel">
                                    &nbsp; No projects</label>
                            </label>
                        </div>
                    </div>
                </section>
                <section class="margin-class">

                    <section class="table-information">
                        <article>
                            <div class="bizComp-table-filter">
                                <div class="table-container">
                                    <div class="row header">
                                        <div class="cell width-300">Business Component Name</div>
                                        <div class="cell width-105">Qualified %</div>
                                        <div class="cell width-200">BC Number</div>
                                        <div class="cell width-200">BC Type</div>
                                    </div>
                                    <div class="row">
                                        <div class="cell width-300">
                                            <input class="custom-input input-one" type="text" maxlength="50"
                                                formControlName="businessCompName"
                                                [ngClass]="{'input-error': form.get('businessCompName').invalid && (form.get('businessCompName').dirty || form.get('businessCompName').touched)}" />
                                        </div>
                                        <div class="cell width-150">
                                            <div class="qualified-toggle-wrapper">
                                                <div>
                                                    <toggle-switch
                                                        [switchState]="form.get('businessCompQPercentage').value > 0"
                                                        (toggleState)="onBusinessCompQPercentageToggle($event)">
                                                    </toggle-switch>
                                                </div>
                                                    <span class="qualified-label">Qualified</span>
                                            </div>
                                        </div>
                                        <div class="cell width-200">
                                            <input class="custom-input input-two" type="text" maxlength="20"
                                                formControlName="bcNumber"
                                                [ngClass]="{'input-error': form.get('bcNumber').invalid && (form.get('bcNumber').dirty || form.get('bcNumber').touched)}" />
                                        </div>
                                        <div class="cell width-200">
                                            <select class="custom-input input-two" formControlName="bcType"
                                                style="padding: 0.85em;">
                                                <option *ngFor="let type of bcTypes" [value]="type.value">{{ type.label
                                                    }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="error-div" *ngIf="form.invalid && (form.dirty || form.touched)">
                                    <label class="error-message" *ngIf="form.invalid && (form.dirty || form.touched)">
                                        {{ getErrorMessage() }}
                                    </label>
                                </div>

                                <div class="input-with-icon table-filter margin-class-one"
                                    *ngIf="(filteredClientProject.length>0 || totalProject>0) ">
                                    <button type='button' class="btn btn-secondary font-class btn-add"
                                        *ngIf="selectedProjects.length <2" (click)="openAddClientProj()">
                                        Add Projects
                                    </button>

                                    <div class="bulk-actions-container "
                                        *ngIf="selectedProjects.length > 1 && !isAssigned" style="margin-left:-1.3em;">
                                        <div class="bulk-actions" *ngIf="selectedProjects.length > 1">
                                            <button type='button' class="btn btn-secondary btn-add"
                                                (click)="toggleBulkActions($event)">
                                                <span class="badge-circle">{{selectedProjects.length}}</span>
                                                Bulk Actions
                                            </button>
                                            <ul
                                                [ngClass]="{'submenu': true, 'show': isBulkActionsVisible, 'bulkactionsmenu': true}">
                                                <li (click)="openDeleteClientProjectConfirmBox(selectedBulkClientProjectId)"
                                                    *ngIf="!isDeleteClientProj" class="font_class"
                                                    style="font-size:14px;"><a>Remove Project</a></li>
                                            </ul>
                                        </div>
                                        <br />
                                    </div>

                                    <input (ngModel)="searchQuery" class="search-bar" placeholder="Search projects"
                                        type="text" required aria-autocomplete="none" aria-expanded="false"
                                        role="search" value="{{searchQuery}}"
                                        (keyup)="searchProjectData($event.target.value)" />

                                    <i class="fa-solid fa-search"
                                        [style.left]=" selectedProjects.length < 2 ? '16.5%' : selectedProjects.length > 1? '19.5%' : '2.5%'"
                                        aria-hidden="true"></i>

                                    <label class="font-class font_small margin-class-three">Projects in this BC </label>
                                    <label class="font-class font_small total-label"
                                        *ngIf="!searchEnabled">{{filteredClientProject.length}}</label>
                                    <label class="font-class font_small total-label"
                                        *ngIf="searchEnabled">{{totalProject}}</label>
                                </div>
                            </div>
                        </article>

                    </section>
                    <br *ngIf="!selectedBusinessComponent.isAllocated" />
                    <span *ngIf="selectedBusinessComponent.isAllocated" class="not-editable__label">This business component is allocated in survey(s), and cannot be deleted.</span>

                    <section class="table-generated-information section_two"
                        *ngIf="filteredClientProject.length>0 || totalProject>0">
                        <ngx-datatable class="data-table" [rows]="filteredClientProject" [headerHeight]="34"
                            [rowHeight]="40" [columnMode]="'force'" [scrollbarV]="true" [scrollbarH]="false"
                            [selected]="selectedProjects" #eiDataTableElement>
                            <ngx-datatable-column [width]="300" [frozenLeft]="true" [resizeable]="false"
                                [draggable]="false" [cellClass]="'my-custom-cell-left column-label_bold'" [flexGrow]="1"
                                prop="clientProjectname" name="CLIENT PROJECT">
                                <ng-template let-column="column" ngx-datatable-header-template>
                                    <span class="table-header header-label">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CLIENT
                                        PROJECT</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    &nbsp;&nbsp;
                                    <a href="#" (click)="toggleMenu($event, rowIndex, row, $event.target)"
                                         class="submenu-icon-button">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span [title]="row.clientProjectname" class="column-label_bold">
                                        {{trimGridValue(row.clientProjectname, 35)}}
                                    </span>
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column [width]="190" [frozenLeft]="true" [sortable]="true"
                                [resizeable]="false" [draggable]="false" [cellClass]="'my-custom-cell-left'"
                                [flexGrow]="2" prop="clientProjectNumber" name="CLIENT PROJECT NO.">
                                <ng-template let-column="column" ngx-datatable-header-template>
                                    <span class="table-header header-label">CLIENT PROJECT NO.</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span [title]=row.clientProjectNumber class="column-label">
                                        {{trimGridValue(row.clientProjectNumber, 30)}}
                                    </span>
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column prop="Description" name="DESCRIPTION" [sortable]="true"
                                [resizeable]="false" [width]="220" [cellClass]="'my-custom-cell-left'"
                                [draggable]="false">
                                <ng-template let-column="column" ngx-datatable-header-template>
                                    <span class="table-header header-label"> DESCRIPTION</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span [title]=row.Description class="column-label">
                                        {{trimGridValue(row.Description, 30)}}
                                    </span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column prop="Description" name="" [sortable]="true" [resizeable]="false"
                                [width]="120" [cellClass]="'my-custom-cell-left'" [draggable]="false">
                                <ng-template let-column="column" ngx-datatable-header-template>
                                    <span class="table-header header-label"> &nbsp;</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span [title]=row.Description class="column-label">
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>

                        <div [ngClass]="{'submenu submenu--row': true, 'show': showRowSubmenu}" class="menu"
                            [style.top.px]="offset">
                            <a href="#" class="menu-item"
                                (click)="openDeleteClientProjectConfirmBox(currentProjectId)">Remove Project</a>
                        </div>
                    </section>

                    <!-- No projects found Section -->
                    <section class="no_records_notification"
                        *ngIf="getFilteredCountAndPercentage(selectedBusinessCompId).count==0">
                        <br />
                        <div class="align-center font-class" style="margin: auto;">
                            <div class="font-size-70">
                                <i class="fa-solid fa-triangle-exclamation"></i>
                            </div>
                            <div class="font-weight">
                                No client projects
                            </div>
                            <div class="margin_four">
                                <p>A business component must have at least one associated</p>
                            </div>
                            <p class="margin_four">projects to be available for time and expense survey creation.</p>
                            <div>
                                <button type='button' class="btn btn-secondary font-weight-class"
                                    (click)="openAddClientProj()">
                                    Add Projects
                                </button>
                            </div>
                        </div>
                    </section>
                    <!--ends-->
                </section>
            </div>

            <!-- No records found Section -->
            <section *ngIf="businessComponents.length==0">
                <br />
                <div class="align-center font-class">
                    <div class="font-size-70">
                        <i class="far fa-folder" aria-hidden="true"></i>
                    </div>
                    <div class="font-weight">
                        No business components
                    </div>
                    <div class="margin_four">
                        <p>Create business components to consolidate multiple client</p>
                    </div>
                    <p class="margin_four">projects into larger units for time and expense surveys.</p>
                    <div>
                        <button type='button' class="btn btn-secondary font-weight-class"
                            (click)="showCreateBusinessComponentDialog()">
                            Create new business component
                        </button>
                    </div>
                </div>
            </section>

            <footer *ngIf="businessComponents.length>0" class="endFormSubmit info-tile" class="footer-style">
                <button type="button" class="link-button-top-border-blue font-class font-small"
                    (click)="showCreateBusinessComponentDialog()"> Create New BC</button>
                <button type='submit' class="btn btn-success save_button"
                    [disabled]="form.invalid || !hasFormChanged()">
                    Save
                </button>
                <button class="btn kpmg-button--flat"
                    (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
                <button *ngIf="!selectedBusinessComponent.isAllocated && !selectedBusinessComponent.hasQualitativeSurvey" type="button"
                    class="delete-btn" (click)="openDeleteBusinessCompConfirmBox()"> Delete this
                    BC </button>
            </footer>
        </form>
    </div>
</section>

<jw-modal id="delete-biz-comp-modal" [ngClass]="isDeleteBizComp ? 'showGuideModal' : 'hideGuideModal'">
    <delete-biz-comp [selectedBusinessCompIdToDelete]="selectedBusinessCompIdToDelete" [engagementId]="engagementId"
        (modelClose)="closeModal('delete-biz-comp-modal')" *ngIf="isDeleteBizComp"></delete-biz-comp>
</jw-modal>

<jw-modal id="add-client-proj-modal" [ngClass]="isAddClientProject ? 'showGuideModal' : 'hideGuideModal'">
    <add-existing-client-proj [selectedBusinessCompId]="selectedBusinessCompId"
        [selectedBusinessCompName]="selectedBusinessCompName" [engagementId]="engagementId"
        (modelClose)="closeModal('add-client-proj-modal')" *ngIf="isAddClientProject"></add-existing-client-proj>
</jw-modal>

<jw-modal id="create-new-bc-modal" [ngClass]="showBCDialog ? 'show-BC-dialog' : 'hide-BC-dialog'">
    <rcn-create-business-component [engagementId]="engagementId" (closeBCDialog)="closeBCDialog()" *ngIf="showBCDialog">
    </rcn-create-business-component>
</jw-modal>

<jw-modal id="remove-client-proj-modal" [ngClass]="isDeleteClientProj ? 'showGuideModal' : 'hideGuideModal'">
    <remove-proj-from-bizcomp [selectedClientProjectId]="selectedClientProjectId"
        [selectedBusinessCompId]="selectedBusinessCompId" [engagementId]="engagementId"
        (modelClose)="closeModal('remove-client-proj-modal')" *ngIf="isDeleteClientProj"></remove-proj-from-bizcomp>
</jw-modal>